module.exports = __webpack_public_path__ + "img/salud-adultos.e5552bff.png";